<template>
  <div v-if="type === 'short'" class="tag text-fg-primary">
    <svg v-if="hasIcon" class="tag-icon w-4 h-4" :data-src="tag.icon_url" />
    <span v-else class="tag-name">{{ firstLetter }}</span>
  </div>
  <div
    v-else
    class="tag rounded-full flex items-center justify-start gap-2 px-2 border border-linear-subtle"
    :class="selected ? 'bg-surface-inverse text-fg-inverse' : 'bg-surface-primary text-fg-primary'"
  >
    <svg v-if="hasIcon" class="tag-icon w-4 h-4" :data-src="tag.icon_url" />
    <span class="tag-name font-semibold text-sm">{{ tag.name }}</span>
  </div>
</template>

<script lang="ts" setup>
import * as _ from 'lodash-es'
import { computed, toRefs } from 'vue'

import { GuestTagRead, ReservationTagRead } from '@generated/types'

type Tag = ReservationTagRead | GuestTagRead
type TagType = 'short' | 'long'

const props = withDefaults(
  defineProps<{
    tag: Tag
    type?: TagType
    selected?: boolean
  }>(),
  {
    type: 'short',
    selected: false,
  },
)
const { tag, type } = toRefs(props)

const hasIcon = computed<boolean>(() => !_.isEmpty(tag.value.icon_url))
const firstLetter = computed<string>(() => _.toUpper(_.first(tag.value.name)))
</script>
